import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { 
  Form, 
  Label,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormFeedback,
} from 'reactstrap';
import { useFormik } from 'formik';
import { toast } from 'react-toastify'
import * as Yup from 'yup';
import { useMutation } from 'react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { forgotPassword } from '../api/actions/auth'
import { fetcher } from '../api/client'
import InputWithLoader from './InputWithLoader';
import LoadingButton from './LoadingButton'
import Alert from './Alert'
import { useTranslation } from "react-i18next";

const defaultValues = {
    email: ''
}

const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email('InvalidEmail')
      .required('Required'),
});

function ForgotPasswordForm({initialValues = defaultValues, error, errorMsg, onSubmit, onErrorClose, onGoToLogin}) {
    const formik = useFormik({
      initialValues,
      validationSchema: ForgotPasswordSchema,
      onSubmit,
    });
    const { t } = useTranslation('common')
    const history = useHistory();
    const handleGoToLogin = () => {
      if (onGoToLogin) return onGoToLogin();
      history.push('/login')
    }

    return  (
        <>
        <Form onSubmit={formik.handleSubmit} noValidate>
            <FormGroup>
                <Label for="email">{t('forms.email')} <span className="text-accent">*</span></Label>
                <InputGroup className="mb-2">
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText><FontAwesomeIcon icon="envelope" className="text-primary" /></InputGroupText>
                    </InputGroupAddon>
                    <InputWithLoader 
                        id="email" 
                        className="form-control" 
                        aria-describedby="emailHelp" 
                        placeholder={t('forms.email')}
                        type="email"
                        name="email"
                        loading={formik.isSubmitting}
                        onChange={formik.handleChange}
                        value={formik.values.email} 
                        invalid={formik.errors.email && formik.touched.email}
                    />
                   <FormFeedback>{t(`errors.${formik.errors.email}`)}</FormFeedback>
                </InputGroup>
            </FormGroup>
            <Alert primary="Error" isOpen={error} toggle={onErrorClose} secondary={t(`errors.${errorMsg}`)} icon="info" size="sm" />
            <div className="mt-4">
                <LoadingButton 
                    className="animate-up w-100 mb-3"
                    color="primary" 
                    type="submit" 
                    loadingText={t('actions.sending')}
                    loading={formik.isSubmitting}
                >
                   {t('actions.send')}
                </LoadingButton>
                <p>
                  {t('auth.alreadyHaveAccount')} 
                  <a className="ml-1" href="#" onClick={handleGoToLogin}>{t('auth.login')}</a>
                </p>
            </div>
        </Form>
    </>
    );
}

function ForgotPasswordFormContainer({ onGoToLogin }) {
  const { t } = useTranslation('common');
  const { mutate: mutateForgotPassword, ...forgotPasswordState }= useMutation((payload) => fetcher(forgotPassword(payload)), {
    onSuccess: () => {
      toast.success(t('successMessages.sentForgotPasswordMessage'))
    }
  });

  const handleSubmit = async (formValues, actions) => {
    await mutateForgotPassword(formValues);
    actions.setSubmitting(false)
  }

  const handleAlertClose = () => {
    forgotPasswordState.reset()
  }

  return <ForgotPasswordForm error={forgotPasswordState.isError} onErrorClose={handleAlertClose} errorMsg={forgotPasswordState?.error?.message} onSubmit={handleSubmit} onGoToLogin={onGoToLogin} />;
}

export default ForgotPasswordFormContainer;

